var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-list-item",on:{"click":_vm.itemClick}},[_c('img',{style:({height:_vm.imgHeight,width:_vm.width}),attrs:{"src":_vm.project.image,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.project.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }